import React, { useEffect, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import { Formik } from 'formik';

import LoadMask from 'components/LoadMask';
import BasicButtonGroup from 'components/BasicButtonGroup';
import BasicButton from 'components/BasicButton';
import BasicSubmitButton from 'components/BasicSubmitButton';
import BasicCheckbox from 'components/BasicCheckbox';
import HorizontalLoader from 'components/HorizontalLoader';

import { useApi } from 'hooks/useApi';
import { ENDPOINT } from 'constants/endpoints';
import { ANIMATION_TIMEOUT_APPEAR } from 'constants/animation.js';

const CandidateMassStatusForm = props => {
  const {
    params: { id, ids },
    actions: { proceed, dismiss, handleError },
  } = props;

  const api = useApi();

  const [formData, setFormData] = useState({
    init: false,
    options: [],
  });

  useEffect(() => {
    api.get(
      ENDPOINT.FORM.GET.STATUS_MASS_PROFILE,
      { id },
      {
        handleError: response => handleError(response),
        handleSuccess: ({ options }) =>
          setFormData({
            init: true,
            options: {
              status: options.status.map(r => ({
                ...r,
                name: r.value.replace(/\s/g, '__'),
              })),
            },
          }),
      }
    );
  }, []);

  const handleSubmit = (values, { setSubmitting }) => {
    api.post(
      ENDPOINT.FORM.SAVE.STATUS_MASS_PROFILE,
      {
        id,
        candidates: ids,
        status: Object.keys(values)
          .filter(key => !!values[key])
          .map(key => key.replace(/__/g, ' ')),
      },
      {
        handleError: response => {
          setSubmitting(false);
          handleError(response);
        },
        handleSuccess: proceed,
      }
    );
  };

  return formData.init ? (
    <CSSTransition
      in={true}
      appear={true}
      timeout={ANIMATION_TIMEOUT_APPEAR}
      classNames="fade"
    >
      <div className="form__inner">
        <Formik onSubmit={handleSubmit}>
          {({
            values,
            errors,
            touched,
            dirty,
            handleChange,
            handleBlur,
            handleSubmit,
            handleReset,
            isSubmitting,
          }) => (
            <form onSubmit={handleSubmit} className="form__content">
              {isSubmitting && <LoadMask />}

              <div className="form__group form__group--compact">
                <div className="form__row form__row--split">
                  <div className="form__column">
                    {formData.options.status.map(status => (
                      <div className="form__row" key={status.name}>
                        <BasicCheckbox
                          value={status.name}
                          singleRow
                          checked={values[status.name] || false}
                          title={status.label}
                          name={status.name}
                          controlFunc={handleChange}
                          labelStyles={{
                            fontFamily: 'Noto Sans, sans-serif',
                          }}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="form__controls form__controls--compact">
                <BasicButtonGroup>
                  <BasicSubmitButton
                    controlFunc={handleSubmit}
                    btnWidth={200}
                    btnHeight={40}
                    btnFontWeight={500}
                    btnFontSize="0.8571rem"
                    btnArrow={true}
                    btnTextColor="#27282d"
                    btnText="Save"
                  />

                  <BasicButton
                    controlFunc={dismiss}
                    btnWidth={200}
                    btnHeight={40}
                    btnFontWeight={500}
                    btnFontSize="0.8571rem"
                    btnArrow={false}
                    btnTextColor="#27282d"
                    btnText="Cancel"
                  />
                </BasicButtonGroup>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </CSSTransition>
  ) : (
    <div className="form__inner">
      <div className="horizontal-loader__container">
        <HorizontalLoader />
      </div>
    </div>
  );
};

export default CandidateMassStatusForm;
